// extracted by mini-css-extract-plugin
module.exports = {"disabled":"DataViewHeaderButton_disabled__3Sb1B","enabled":"DataViewHeaderButton_enabled__BWLf3","root":"DataViewHeaderButton_root__R9BQn"};